const targetNodes = document.querySelectorAll('.fancybox-product-gallery-video-anchor');

const callback = function(mutationsList) {
  mutationsList.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
      mutation.target.style.display = 'inline'
    }
  });
};

const observer = new MutationObserver(callback);

targetNodes.forEach(function(targetNode) {
  observer.observe(targetNode, {
    attributes: true,
    attributeFilter: ['style'] 
  });
});